import React, { createContext, useContext, ReactNode } from "react";

import { BalloonEventsMapOptions } from "../types/EmbedOptions";

const BalloonEventsOptionsContext = createContext<
  BalloonEventsMapOptions | undefined
>(undefined);

type BalloonEventsOptionsProviderProps = {
  children: ReactNode;
  options: BalloonEventsMapOptions;
};

export const BalloonEventsOptionsProvider: React.FC<
  BalloonEventsOptionsProviderProps
> = ({ children, options }) => {
  return (
    <BalloonEventsOptionsContext.Provider value={options}>
      {children}
    </BalloonEventsOptionsContext.Provider>
  );
};

export function useBalloonEventsOptions(): BalloonEventsMapOptions {
  const context = useContext(BalloonEventsOptionsContext);
  if (!context) {
    throw new Error(
      "useBalloonEventsOptions must be used within a BalloonEventsOptionsProvider"
    );
  }
  return context;
}
